import { createContext } from 'react';

/**
 * Props for the menu context.
 */
interface Props {
  collapse: boolean;
  display: boolean;
  effectiveIndex: React.MutableRefObject<number>;
  setListIndex: React.MutableRefObject<
    (newIndex: number, increment?: number) => void
  >;
}

/**
 * Menu context.
 */
const MenuContext = createContext<Props>({
  collapse: false,
  display: false,
  effectiveIndex: { current: 0 },
  setListIndex: { current: () => null },
});

export default MenuContext;
export type { Props };
